import React, { createContext, useContext, useEffect, useState } from "react";

const HelpChatContext = createContext(null);
const OPEN_STORAGE_KEY = "helpChatOpen";

function loadOpen() {
  try {
    return sessionStorage.getItem(OPEN_STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

/** Controls whether the Help & Support chat widget panel is open — toggled
 * from the sidebar "Help & Support" button (no more floating bubble). */
export function HelpChatProvider({ children }) {
  const [open, setOpen] = useState(loadOpen);

  useEffect(() => {
    try {
      sessionStorage.setItem(OPEN_STORAGE_KEY, open ? "1" : "0");
    } catch {
      // best-effort — ignore storage errors (e.g. private mode quota)
    }
  }, [open]);

  // Global trigger — lets components mounted outside this provider's tree
  // (e.g. the mobile drawer, mounted at the App root) open the widget too.
  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener("open-help-chat", handler);
    return () => window.removeEventListener("open-help-chat", handler);
  }, []);

  const toggle = () => setOpen((v) => !v);

  return (
    <HelpChatContext.Provider value={{ open, setOpen, toggle }}>
      {children}
    </HelpChatContext.Provider>
  );
}

export function useHelpChat() {
  const ctx = useContext(HelpChatContext);
  if (!ctx) throw new Error("useHelpChat must be used within a HelpChatProvider");
  return ctx;
}
